export default {
    name: "jobDetail",
    data: function() {
        return {
            tab: "info",
            alert: {
                isshow: false,
            },
            isLogin: this.$isLogin(), //是否登录
            curTabId: this.$route.query.tabid ? parseInt(this.$route.query.tabid) : 0, //用于返回列表定位状态
            casual: this.$route.query.casual ? this.$route.query.casual : false, //不确定参数，目前用来判断是否显示返回按钮
            userType: this.$route.query.userType, //用户类型，目前用于判断下载引导条显示类型（c:经理端下载 else:用户端下载）
            detailList: this.$route.query.detailList, //是否显示应聘阿姨列表
            jobDetail: [],

            cityId: 310100,

            dealAmount: "", //成交金额
            dealDate: "", //成交日期

            isMiniProgram: this.$isMiniProgram(), //是否小程序环境
            isAPP: false, //是否APP环境
            //下载引导条
            downloadGuideBarMain: require("../../shared/assets/images/download/download_guide_bar_ally_main_gray.png"),
            downloadGuideBarClose: require("../../shared/assets/images/download/download_guide_bar_btn_close_gray.png"),
            downloadGuideBarBtnCont: {
                text: "打开"
            },
            isShowDownloadGuideBar: false,
        }
    },
    mounted: function() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'jobDetail') {
                this.init();
            }
        }
    },
    computed: {
        size: function() {
            return document.documentElement.clientWidth * 1.8 / 7.5
        }
    },
    methods: {
        //检测当前环境
        checkCurPlatform() {
            this.isMiniProgram = this.$isMiniProgram();
            this.isAPP = dsBridge.hasNativeMethod('getSession');
            if (!this.isMiniProgram && !this.isAPP) {
                this.isShowDownloadGuideBar = true;
            }
        },
        init: function() {
            var _this = this;
            this.isLogin = this.$isLogin(); //是否登录
            this.casual = this.$route.query.casual ? this.$route.query.casual : false;
            this.userType = this.$route.query.userType;
            this.detailList = this.$route.query.detailList;
            this.checkCurPlatform();
            let _params = {
                JobId: this.$route.query.id
            };
            if(this.detailList){
                _params.d = this.detailList;
            }
            this.$post("/customerservicemanager/getjobdetail", _params, function(result) {
                if (result) {
                    _this.jobDetail = result;
                } else {
                    _this.$toast('获取详情失败');
                }
            });
        },
        recommend: function(job) {
            let self = this;
            if(!this.isLogin){
                this.$toast("请先登录");
                dsBridge.call("login", "", function(session) {
                    window.sessionStorage.setItem("session", session);
                    self.init();
                });
                return false;
            }
            //TODO remove
            var jobTypeObj = {
                "临时保洁": 1,
                "长期钟点工": 2,
                "全天保姆": 3,
                "住家保姆": 4,
                "月嫂": 5,
                "育婴师": 6,
                "催乳师": 7,
                "专业除螨": 8,
                "早出晚归": 9,
                "其他": 99
            };
            var jobType = jobTypeObj[job.JobTypeStr] || 99;

            this.$router.push({
                name: "serverList",
                query: {
                    id: job.JobId,
                    jobType: jobType,
                    jobTypeStr: encodeURIComponent(job.JobTypeStr),
                    catId: jobType //新列表页
                }
            });
        },
        changeServant: function(job) {

        },
        //确认成交
        confirmDeal(id) {
            let self = this;
            this.dealId = id;
            self.alert = {
                cont: "",
                cancelauto: true,
                callback: self.doDeal,
                isCustomClose: true,
                isSlot: true,
                isOperation: true,
                isCornerClose: true,
            };
            self.alert = self.$uAlert.show_alert(self.alert);
        },
        doDeal() {
            var self = this;
            if (!self.dealAmount || self.dealAmount == "" || self.dealAmount <= 0) {
                // alert("请按合同金额正确输入");
                self.$toast("请按合同金额正确输入", 2000);
                return false;
            }

            //提交数据
            this.$post("/servant/createcontract", {
                "JobId": self.jobDetail.JobId,
                "ServantAccountCode": self.jobDetail.ListJobServant[0].ServantAccountCode,
                "ProfileStoreId": self.jobDetail.ListJobServant[0].ServantStoreId,
                "ContractAmount": self.dealAmount
            }, function(result) {
                if (result.Success) {
                    self.init();
                    //提交后关闭对话框
                    self.alert = {
                        isshow: false,
                    };
                } else {
                    self.$toast(result.Message);
                }
            })

        },
        viewServant(servant) {
            if(!this.detailList){
                let _param = {
                    jobType: servant.JobType,
                    platform: 2
                };
                //this.catList.map(item => {
                //  if (item.selected) {
                //    _param.catId = item.key;
                //  }
                //});
                this.$router.push({
                    path: "/serverDetail/" + servant.ServantId + "/0",
                    query: _param
                });
            }
        },
        //自定义返回
        customBack(){
            this.$router.push({
                path: "/distributedOrderList",
                query: {
                    tabid: this.curTabId
                }
            });
        },

        //下载引导条开关
        switchDownloadGuideBar() {
            this.isShowDownloadGuideBar = !this.isShowDownloadGuideBar;
        },
        //下载引导条处理事件
        handleDownloadGuideBar(){
            let self = this;
            let downloadType = self.userType && self.userType=="c" ? 0 : 2;
            let isWechat = self.$isWechat();
            if(!isWechat && !self.isAPP && !self.isMiniProgram){
                // window.location.href = "openwjtr://com.tyrbl.wjtr";
                let localUrl = window.location.href;
                localUrl = localUrl.split("detailList")[0];
                let phoneType = self.$getPhoneType();
                if(self.userType && self.userType=="c"){ //客户端下载页
                    if(phoneType=="IOS"){
                        window.location.href = "unionplusapp://";
                    }
                    //Android
                } else { //经理端下载
                    //Android
                    let AndroidUrl = "intent://uplusally?url="+ encodeURIComponent(localUrl) +"#Intent;scheme=uplusally;package=com.taiqi001.uplusally;S.browser_fallback_url=" + encodeURIComponent("https://u.taiqi001.com/#/downloadLanding?downloadType=2") + ";end";
                    // let AndroidUrl = "intent://uplusally#Intent;scheme=uplusally;package=com.taiqi001.uplusally;S.browser_fallback_url=https://www.baidu.com;end";
                    window.location.href = AndroidUrl;
                }
                let delayToLanding = setTimeout(() => {
                    self.$router.push({
                        path: "/downloadLanding",
                        query: {
                            downloadType: downloadType
                        }
                    });
                },3000);
            } else {
                self.$router.push({
                    path: "/downloadLanding",
                    query: {
                        downloadType: downloadType
                    }
                });
            }
        },
    },
}


// WEBPACK FOOTER //
// ./src/ally/page/jobDetail.js